import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
state: {
user:{},
spinShow:false,
views:[],
moduleData:{},
menuFlag:false,
leftMenuFlag:false,
catch_components:[],
  deviceSet: [],
initTopoFlag:false,
ipTopoData:{},
crm_id:'',
    ipTopoShowFlag: false,
    showEventFlag: false,
    currentTabName: "",
    graph: {},

  },
mutations: {
  updateUser:function(state,u){
    state.user=u;
},
/***全局loading**********/
updateSpinShow(state,value){
state.spinShow=value;
},
updateModuleData:function(state,data){
state.moduleData=data;
},
updateMenuFlag(state,flag){
state.menuFlag=flag
},
updateLeftMenuFlag(state,flag){
state.leftMenuFlag=flag
},
GET_CATCHE_COMPONENTS(state,data){
state.catch_components = data
},
  /**设备图更改数据 */
  updateIpTopoData(state,data){
    state.ipTopoData = data;
  },
  /**更换crm_id*/
  updateCrmId(state,data){
    state.crm_id = data;
  },
  /**更新根因分析拓扑初始化标志*/
  updateInitTopoFlag(state,data){
    state.initTopoFlag = data;
  },
    /**更新事件显示标志*/
    updateIpTopoShowFlag(state, flag) {
      state.showEventFlag = flag;
    },
    updateDeviceSet(state,data){
      state.deviceSet = data;
    },

    /**更新当前页签*/
    updateCurrentTabName(state, data){
      state.currentTabName = data;
    },
    /**更新当前页签*/
    updateGraph(state, data){
      state.graph = data;
    },

    },
getters:{
catch_components(state){
return state.catch_components;
}
}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js